<script>
	import { fade } from 'svelte/transition';
	import { scaleAdOnHover, startAd, pauseAd, stopAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		autoVideo: {
			element: false,
			fallbackImgUrl: './../video/Opel_Combo_system_2.webp',
			imageAltText: 'Opel-Case-Study - Auto-Video - Video-Ad',
			videoUrl: './../video/OPEL-SK001_ComboME_Phase2_WM_System.mp4',
			playTimeMs: 14000, //ganzes video von vorn = 14 sekunden + standbild bei 14 sekunden
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false,
			posterImgOffsetS: 14,
			posterImg: './../video/Opel_Combo_system_2.webp',
			volume: .2,
			showPauseButton: false
		}
	}

	function autoVideoHidePauseButtonTimer() {
			ads.autoVideo.showPauseButton = false;
	}

	let autoVideoHidePauseButtonTimerVar;
</script>

<div class="page-opel marginbox">
	<div class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<!-- Beginning - autoVideo -->
				<div bind:this={ads.autoVideo.element} class="content">
					<div use:scaleAdOnHover={ads.autoVideo} class="commercial" on:click={() => !ads.autoVideo.playing ?
					startAd(ads.autoVideo, () => ads = ads) : null}>
						<video playsinline loop="true"
							   on:loadeddata={() => stopAd(ads.autoVideo, () => ads = ads)}
							   on:mousemove={() => {
								   clearTimeout(autoVideoHidePauseButtonTimerVar);
								   ads.autoVideo.showPauseButton = true;
								   autoVideoHidePauseButtonTimerVar = setTimeout(autoVideoHidePauseButtonTimer, 2000);
							   }}
							   scrolling="no"
							   src={ads.autoVideo.videoUrl}
						/>
						{#if ads.autoVideo.playing}
							<!-- PLAYING -->
							{#if ads.autoVideo.showPauseButton}
								<button aria-label="pause Ad - {ads.autoVideo.imageAltText}" transition:fade class="pausebutton"
										on:click={() => pauseAd(ads.autoVideo, () => ads = ads)}></button>
							{/if}
						{:else}
							<img loading="lazy" class="posterImg" alt={ads.autoVideo.imageAltText} src={ads.autoVideo.posterImg}/>
							<!-- NOT PLAYING -->
							<button aria-label="play Ad - {ads.autoVideo.imageAltText}" class="audiobutton"></button>
						{/if}
					</div>
				</div>
				<!-- End - autoVideo -->
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Opel-Run" src="./../img/19.Opel_Case_Study/06.kreativitaet/opel_run.webp">
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Combola" src="./../img/19.Opel_Case_Study/06.kreativitaet/Schnittmenge4.webp">
			</div>
		</div>
		
		<div class="flex row structure-2">
			<div class="flex element">
				<div class="text">
					<h2>{getText("19.06.01_h2")}</h2>
					<p class="caption">{getText("19.06.02_caption")}</p>
				</div>
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Sternwarte" src="./../img/19.Opel_Case_Study/06.kreativitaet/sternwarte.webp">
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Combonationsspiel" src="./../img/19.Opel_Case_Study/06.kreativitaet/OPEL-SK001_ComboME_WM_Combonationsspiel_K.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.posterImg {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: auto;
		z-index: 1;
	}
	
	.page-opel {
		h2 {
			margin-bottom: $media-gap;
		}
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: fit-content;
			line-height: 0;
		}
		
		.content {
			flex: 1 100%;
		}

		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1 {
			width: 100%;
			padding: 0;
			
			@include for-tablet-portrait-up {
				width: 50%;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;

				&:last-of-type {
					@include for-tablet-portrait-up {
						margin-bottom: 0;
					}
				}
			}
			
			.content .commercial {
				height: auto;
				border: .75px solid $color-burgeins-1;
			}
		}
		
		.structure-2 {
			width: 100%;
			padding: 0;
			margin-bottom: $spacing-mobile;

			@include for-tablet-portrait-up {
				width: 50%;
				padding-left: $media-gap;
				margin-bottom: 0;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;

				&:first-of-type {
					@include for-tablet-portrait-up {
						margin-bottom: auto;
					}
				}

				&:last-of-type {
					@include for-tablet-portrait-up {
						margin-bottom: 0;
					}
				}
			}
		}

		.structure-1,
		.structure-2 {
			@include for-tablet-portrait-up {
				flex-flow: column wrap;
				justify-content: space-between;
			}
		}
		
		.text {
			margin: 0 0 $media-gap 0;
		}
	}
	
	video {
		width: 100%;
		position: relative;
		z-index: 1;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(video[loaded]) {
		background-image: none !important;
	}
</style>
